import styled from 'styled-components'

import { keepBlockSelectionAttribute } from '../constants'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${props => props.theme.spacing.sp16};
  flex-shrink: 0;
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp24};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
`

export const PreviewSettings = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  margin-right: auto;
`

export const Separator = styled.div`
  width: 1px;
  align-self: stretch;
  margin: -${props => props.theme.spacing.sp8} 0;
  background-color: ${props => props.theme.colors.border.subtle};
`

export const ExpandBlocksSidebar = styled.div.attrs({ [keepBlockSelectionAttribute]: '' })`
  display: flex;
  align-items: center;
`
